module.exports = __webpack_public_path__ + "static/media/UNIDLogoButton.21c6141d.svg";